export default __webpack_public_path__ + "static/media/google authenticator.a0075d22.png";